// The shared table's checkbox: the kit's Checkbox at its table size (16px), bare. Name it with
// aria-label. Standard input props pass straight through; `type` is fixed.
import React from 'react';
import Checkbox, { CheckboxProps } from '../ui/Checkbox';

type TableCheckboxProps = Omit<CheckboxProps, 'label' | 'description' | 'size' | 'labelSide' | 'fill'>;

const TableCheckbox: React.FC<TableCheckboxProps> = (props) => <Checkbox size="sm" {...props} />;

export default TableCheckbox;
